import React, {Suspense} from 'react';
import Hero from "../hero/Hero";
import Article from "../article/Article"
import { Helmet } from "react-helmet";
import { StyledPageHome } from './styled'
import ContactForm from "../contact-form/ContactForm";
import Placeholder from "../generic/Placeholder";
import { Link } from "react-router-dom";

const PageHome = () => {
    return (
        <>
            <Helmet>
                <title>Omniquad</title>
                <meta name="description" content="Advanced internet security services for business. See how Omniquad's Email protection can meet all your online security needs."/>
            </Helmet>
            <main className={"Page"}>
                <Hero showButtons>
                    <h1>When Business is complex,
                        We make IT security simple.</h1>
                    <p>See how Omniquad’s Cloud Email protection can meet all your online security needs. Email Filtering, Web Filtering, Archiving, Data Loss Prevention, and more...</p>
                </Hero>
                <StyledPageHome>
                    <Article>
                        <section className="PageHome-card-deck">
                            <Link to='/mailwall-email-filtering'>
                                <h2>Mailwall</h2>
                                <strong>Cloud Hosted Email Security</strong>
                                <div>
                                    Comprehensive email protection from spam 
									Block 99.99% email threats efficient and secure anytime, anyplace, anywhere..
                                </div>
                            </Link>

                            <Link to='/surfwall-internet-security'>
                                <h2>Surfwall</h2>
                                <strong>Hosted web security and access control management</strong>
                                <div>
                                    Block malicious websites, applications and downloads,
                                    manage internet use in your organization, reduce
                                    security risks with increased efficiency and productivity.
                                </div>
                            </Link>

                            <Link to='/email-archiving-secure-backup-and-recovery'>
                                <h2>Email Archiving</h2>
                                <strong>Secure email archiving, back-up and recovery</strong>
                                <div>
                                    Email archiving in the Cloud provides storage of emails with
                                    secure access for protection, backup and easy email recovery.
                                    Your emails are secure, yet at your fingertips.
                                </div>
                            </Link>

                            <Link to='/phishwise-internet-security-training'>
                                <h2>Phishwise</h2>
                                <strong>Spear-Phishing Vulnerability Assessment for users.</strong>
                                <div>
                                    Ensure that your employees get first‑hand experience
                                    of spear‑phishing, as well as learn about the risks,
                                    and how to protect themselves and your organization.
                                </div>
                            </Link>
                        </section>
                    </Article>
                </StyledPageHome>
            </main>
            <Suspense fallback={<Placeholder />}>
                <ContactForm/>
            </Suspense>
        </>
    )
}

export default PageHome;
